import type { SVGProps } from "react";

export function WalletIcon(props: SVGProps<any>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={23.652} height={20.166} viewBox="0 0 23.652 20.166" {...props}>
      <path
        fill="currentColor"
        fillOpacity={1}
        fillRule="nonzero"
        d="M2.959 20.166h15.703c1.963 0 2.95-.986 2.95-2.91v-2.822h-1.583v2.734c0 .947-.508 1.416-1.396 1.416H2.979c-.899 0-1.387-.469-1.387-1.416V7.236c0-.937.488-1.425 1.387-1.425h15.654c.889 0 1.396.488 1.396 1.425V9.61h1.582V7.15c0-1.924-.986-2.92-2.949-2.92H7.812c-.166 0-.185-.157-.01-.196l7.55-2.09c.937-.273 1.425.069 1.425.928v2.031l1.592-.136V3.008c0-2.305-1.582-3.018-3.72-2.403L2.128 4.248C.664 4.688 0 5.576 0 7.148v10.108c0 1.933 1.006 2.91 2.959 2.91Zm14.834-7.002c.547 0 .986-.44.986-.986a.984.984 0 0 0-.986-.987.984.984 0 0 0-.986.987c0 .547.44.986.986.986Zm-.098 2.09h3.614c1.22 0 1.982-.86 1.982-1.982v-2.168c0-1.124-.762-1.973-1.982-1.973h-3.614c-1.972 0-3.29 1.015-3.29 3.056 0 2.051 1.318 3.067 3.29 3.067Zm.098-1.309c-1.367 0-2.012-.664-2.012-1.758 0-1.093.645-1.757 2.012-1.757h3.174c.674 0 1.025.38 1.025 1.015v1.485c0 .635-.351 1.015-1.025 1.015h-3.174Z"
      />
    </svg>
  );
}
